import moment from "moment";
import React, { useEffect } from "react";
import Image from "react-bootstrap/Image";

import profilepic from "assets/images/profile-pic.jpg";
import { useSaleProceedHook } from "hooks/property/SaleProceed";

function NotificationBox() {
  const {
    NotificationList,
    NotificationListData,
    isNotificationListUninitialized,
  } = useSaleProceedHook();
  useEffect(() => {
    if (isNotificationListUninitialized) {
      NotificationListing();
    }
  }, [isNotificationListUninitialized]);
  const NotificationListing = async () => {
    await NotificationList({
      page: 1,
      pageSize: 15,
      searchText: "",
      sortColumn: "createdAt",
      sortDirection: -1,
    });
  };
  return (
    <>
      <div className="dropdown-menu ctm-dropdown dropdown-lg shadow onhover-show-div show">
        <div className="dropdown-header flex-between-baseline">
          <span className="dropdown-title">Notification</span>
          <a
            href="/settings/notifications"
            className="link-primary anchor-hover p-0"
          >
            View all
          </a>
        </div>
        <ul className="list-unstyled dropdown-list">
          {NotificationListData?.data?.map((item) =>
            !item.isRead ? (
              <li key={item?._id}>
                <div className="w-100 notification-item flex-between-start">
                  <figure className="avatar-32 rounded-circle d-none">
                    <Image src={profilepic} alt="profile-pic" />
                  </figure>
                  <div className="messages w-100">
                    <span className="username">
                      <a href="#" className="fw-500  p-0 pb-4 text-black">
                        {item?.title}
                      </a>
                      <a className="close fw-semibold p-0" href="javascript:;">
                        <span className="icn-close"></span>
                      </a>
                    </span>
                    <div
                      className="d-flex w-100 justify-content-between align-items-start"
                      style={{ minHeight: "40px" }}
                    >
                      <div className="flex-grow-1 pe-2">{item?.body}</div>
                      <div className="msg-time text-end ms-auto">
                        {moment(item?.createdAt).format("HH:mm")}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ) : null
          )}
        </ul>
      </div>
    </>
  );
}

export default NotificationBox;
